import StorageManager from "~/lib/helpers/StorageManager";
import { getContextId, setContextId, readContextIdFromResponse, ensureContextId } from "~/lib/helpers/ContextId";

export default class BaseApiServer1Service {
  private baseUrl: string;
  private headers: HeadersInit;

  constructor() {
    this.baseUrl =
      typeof window === "undefined"
        ? process.env.REMIX_APP_API_HOST_V2 || "https://apiv2.office-hub.com"
        : "https://apiv2.office-hub.com";
    this.headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    const token = StorageManager.get("token");
    if (token) {
      this.headers["Authorization"] = token;
    }
  }

  private getHeadersWithIp(userIp?: string): HeadersInit {
    const headers = { ...this.headers };
    // headers['Cache-Control'] = 'no-store'
    if (userIp) {
      headers["x-vercel-ip"] = userIp;
    }
    // Inject API Secret for server-side calls
    if (typeof window === "undefined" && process.env.API_SECRET_KEY) {
      headers["x-api-secret"] = process.env.API_SECRET_KEY;
    }
    const ctx = ensureContextId();
    if (ctx) headers["X-Context-Id"] = ctx;
    return headers;
  }

  private async handleResponse(response: Response) {
    const ctxId = readContextIdFromResponse(response);
    if (ctxId) setContextId(ctxId);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      // Only log errors in development
      if (typeof window === "undefined" || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        console.error("FROM BaseApiServer1Service");
        console.error("OH-ERROR", JSON.stringify(errorData, null, 2));
      }
      throw new Error(response.statusText);
    }
    return response.json();
  }

  async apiGet(path: string, userIp?: string) {
    const response = await fetch(`${this.baseUrl}${path}`, {
      method: "GET",
      headers: this.getHeadersWithIp(userIp),
    });
    return this.handleResponse(response);
  }

  async apiPost(path: string, data?: any, userIp?: string) {
    const response = await fetch(`${this.baseUrl}${path}`, {
      method: "POST",
      headers: this.getHeadersWithIp(userIp),
      body: JSON.stringify(data),
    });
    return this.handleResponse(response);
  }
}
